import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import { ACTIVITY_TYPE, ERROR_MESSAGES } from "../../../../utils/constants";
import { useUpdateVendorAuditSchedule } from "../../../../backend/masters";
import { ACTIVITY_STATUS, STATUS_MAPPING } from "../../../common/Constants";
import PageLoader from "../../../shared/PageLoader";
import { AxiosError } from "axios";

function StatusTmp({ status }: any) {
  return <span className={`status-${status}`}>{STATUS_MAPPING[status]}</span>;
}

function VendorUnBlockModal({ activity = {}, onClose, onSubmit }: any) {
  const [newDueDate, setNewDueDate] = useState<any>(new Date());
  const { updateAuditSchedule, updating } = useUpdateVendorAuditSchedule(
    (response: any) => {
      if (response instanceof AxiosError){
          const data = (response.response || {}).data;
          const error = (data || {}).error || ERROR_MESSAGES.DEFAULT;
          toast.error(error);
      } else {
          toast.success('Activity unblocked successfully.');
          onClose();
          onSubmit();
      }
    }
  );

  function submit() {
    const { id } = activity;

    const payload = {
      todo_vendor: {
        id,
        dueDate: new Date(newDueDate).toISOString(),
        status: [ACTIVITY_STATUS.OVERDUE].includes(activity.status) ? ACTIVITY_STATUS.PENDING : activity.status
      }
    };
    updateAuditSchedule(payload);
  }

  function isValid() {
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    today.setMilliseconds(0);
    return newDueDate && newDueDate >= today;
  }

  return (
    <>
      {
        <Modal show={true} backdrop="static" animation={false} size="lg">
          <Modal.Header closeButton={true} onHide={onClose}>
            <Modal.Title className="bg">Un-Block Activity</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex justify-content-center">
              <div className="col-11">
                <div className="row mb-2">
                  <div className="col-4 filter-label">Act</div>
                  <div className="col">{(activity.act || {}).name}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 filter-label">Rule</div>
                  <div className="col">{(activity.rule || {}).name}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 filter-label">
                    Forms/Registers & Returns3
                  </div>
                  <div className="col">{(activity.activity || {}).name}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 filter-label">Activity Type</div>
                  <div className="col">{(activity.activity || {}).activity_type}</div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 filter-label">Month(Year)</div>
                  <div className="col">
                    {activity.month} ({activity.year})
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 filter-label">Evidence Status</div>
                  <div className="col">
                    {activity.status && <StatusTmp status={activity.status} />}
                  </div>
                </div>
                <div className="row mb-2">
                  <div className="col-4 filter-label">Audit Type</div>
                  <div className="col">
                    {activity.auditted || ACTIVITY_TYPE.AUDIT}
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-4 filter-label">Due Date</div>
                  <div className="col-3">
                    <DatePicker
                      className="form-control"
                      selected={newDueDate}
                      dateFormat="dd-MM-yyyy"
                      onChange={setNewDueDate}
                      placeholderText="dd-mm-yyyy"
                      minDate={new Date()}
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-between">
            <Button
              variant="outline-secondary"
              onClick={onClose}
              className="btn btn-outline-secondary"
            >
              Back
            </Button>
            <Button variant="primary" onClick={submit} disabled={!isValid()}>
              Un-Block
            </Button>
          </Modal.Footer>
        </Modal>
      }
      {updating && <PageLoader />}
    </>
  );
}

export default VendorUnBlockModal;
